var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"first-rank-box"},[_c('h3',{staticClass:"nickname"},[_vm._v(_vm._s(_vm.info.nickname))]),_c('p',{staticClass:"tip"},[_vm._v("占领排行榜封面")]),_c('img',{staticClass:"avatar",attrs:{"src":_vm.info.avatar_small},on:{"click":_vm.jumpToPerson}})])
}
var staticRenderFns = []

export { render, staticRenderFns }